import { axiosInstance } from "helpers";

export const deleteSite = async (data) => {
  return axiosInstance
    .post("delete_website", {
      api_key: localStorage.getItem("apikey"),
      user_id: localStorage.getItem("user_id"),
      ...data,
    })
    .then((res) => res.data)
    .catch((err) => new Error(err));
};
